import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../../css/Projects.css";
import '../../css/newprojectstatus.css'
import { FiMapPin, FiHome, FiDollarSign, FiSearch, FiPhoneCall, FiShield, FiSquare } from 'react-icons/fi';
import Select from 'react-select';
import noresultsfound from '../../images/no-results found.jpeg';
import { useNavigate, useSearchParams, useParams } from 'react-router-dom';
import { Navbar } from '../userfolder/Navbar';



const typeOptions = [
  { value: 'Residential', label: 'Residential' },
  { value: 'Commercial', label: 'Commercial' }
];

const minPriceOptions = [
  { value: 2000000, label: '₹20 Lakhs' },
  { value: 4000000, label: '₹40 Lakhs' }
];

const maxPriceOptions = [
  { value: 5000000, label: '₹50 Lakhs' },
  { value: 10000000, label: '₹1 Cr' }
];

const cityOptions = [
  { value: 'Chennai', label: 'Chennai' },
  { value: 'Bangalore', label: 'Bangalore' }
];

export const Gatedcommunities = ({projecttype}) => {

    const [projects, setProjects] = useState([]);
  const [type, setType] = useState('');
  const [propertyType, setPropertyType] = useState('');
  const [builders, setBuilders] = useState([]);
  const [builder, setBuilder] = useState('');

  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [city, setCity] = useState('');
  const [localityList, setLocalityList] = useState([]);
  const [localities, setLocalities] = useState('');
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`/api/get-by-type/${encodeURIComponent(projecttype)}`)
      .then((res) => setProjects(res.data))
      .catch((err) => console.error("Failed to fetch projects", err));
    console.log("status", projecttype);
    console.log("Projects fetched:", projects.image);
  }, [projecttype]);


  useEffect(() => {
    axios.get(`/api/builders`)
      .then(res => setBuilders(res.data))
      .catch(err => console.error("Failed to fetch builders", err));

    axios.get(`/api/localities`)
      .then(res => setLocalityList(res.data))
      .catch(err => console.error("Failed to fetch localities", err));
  }, []);


  const handleSearch = () => {
    const query = {
      type,
      propertyType,
      builder,
      min_price: minPrice,
      max_price: maxPrice,
      city,
      locality: localities,
      property_type: projecttype
    };

    axios
      .get('/api/search-projects', { params: query })
      .then((res) => setProjects(res.data))
      .catch((err) => console.error("Search failed", err));
  };

  const builderOptions = builders.map(b => ({ value: b.builder, label: b.builder }));
  const localityOptions = localityList.map(l => ({ value: l.locality, label: l.locality }));


  return (
    <div> <div className='new-projects-by-status'>
      <Navbar />
      <div className="project-filter-bar">
        <Select
          value={typeOptions.find(option => option.value === type)}
          onChange={(selectedOption) => setType(selectedOption.value)}
          options={typeOptions}
          placeholder="Select Type"
          className="react-select-container" classNamePrefix="react-select"
        />

        <Select
          value={builderOptions.find(option => option.value === builder)}
          onChange={(selectedOption) => setBuilder(selectedOption.value)}
          options={builderOptions}
          placeholder="Select Builder"
          className="react-select-container" classNamePrefix="react-select"
        />

        <Select
          value={minPriceOptions.find(option => option.value === minPrice)}
          onChange={(selectedOption) => setMinPrice(selectedOption.value)}
          options={minPriceOptions}
          placeholder="Min. INR"
          className="react-select-container" classNamePrefix="react-select"
        />

        <Select
          value={maxPriceOptions.find(option => option.value === maxPrice)}
          onChange={(selectedOption) => setMaxPrice(selectedOption.value)}
          options={maxPriceOptions}
          placeholder="Max. INR"
          className="react-select-container" classNamePrefix="react-select"
        />

        <Select
          value={cityOptions.find(option => option.value === city)}
          onChange={(selectedOption) => setCity(selectedOption.value)}
          options={cityOptions}
          placeholder="Select City"
          className="react-select-container" classNamePrefix="react-select"
        />

        <Select
          value={localityOptions.find(option => option.value === localities)}
          onChange={(selectedOption) => setLocalities(selectedOption.value)}
          options={localityOptions}
          placeholder="Select Locality"
          className="react-select-container locality" classNamePrefix="react-select"
        />
        <button onClick={handleSearch} className="search-btn">Search</button>
      </div>
      <div className="project-list-new">
        <u>  <h2>{projecttype}</h2></u>
        <div className="projects-grid">
          {projects.length === 0 ? (
            <div className="no-results">
              <img src={noresultsfound} alt="No results" className="no-results-img" />
              <p className="no-results-text">No projects found matching your criteria.</p>
            </div>
          ) : (
            projects.map((project) => (

              <div key={project.projectid} className="property-card1" onClick={() => navigate(`/new-project/${project.projectid}`)}>
                <div className="card-image">
                  <img src={project.image} alt={project.bpn} />
                  <span className="badge verified"><FiShield /> Verified</span>
                </div>
                <div className="card-content">
                  <h3>{project.bpn}</h3>
                  <div className="flex">
                    <p className="developer">{project.builder}</p> |
                    <p className="devr">{project.property_type}</p>
                  </div>
                  <p className="icon-text"><FiMapPin /> {project.city}, {project.locality}</p>
                  <div className='flex'>
                    <p className="icon-text">
                      <FiHome /> {project.bhk_range?.replace(/bhk/gi, '').split(',').join('&')} BHK
                      <FiSquare/> {project. measurement }:{project.starting_unit_size} - {project.end_unit_size } 
                    </p>
                    <p className="icon-text">
                      ₹{project.min_price} - ₹{project.max_price}
                    </p>
                  </div>
                  <div className="card-actions">
                    <button className="btn view"><FiSearch /> View Details</button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

    </div>
    </div>
  )
}
